import {Form} from './form';
import {Config} from '../config';
import {QuantityView} from '../view/quantity-view';
import { SimpleEventDispatcher } from 'strongly-typed-events';
import { QuantityValidator } from '../validators/quantity-validator';
import { Validator } from '../validators/validator';

export class QuantityForm extends Form {

    private _onQuantityChange = new SimpleEventDispatcher<number>();

    quantity = 1;
    previousQuantity = 1;
    view: QuantityView = new QuantityView();
    validator: Validator = new QuantityValidator();

    get onQuantityChange() {
        return this._onQuantityChange.asEvent();
    }

    constructor() {
        super();
        this.validators.push(this.validator);
    }

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        return Promise.resolve();
    }

    async render(id?: string, productName?: string, isAddon?: boolean) {
        this.view.renderQuantityForm(this.setQuantity.bind(this), id as string, productName as string, isAddon);
    }

    private setQuantity(quantity: number, id?: string, isAddon?: boolean): void {
        this.previousQuantity = this.quantity;
        this.quantity = quantity;
        this.paymentData.quantity = quantity;

        if (id && isAddon) {
            this.triggerEvent('setQuantity_' + id);
        } else {
            this.triggerEvent('setQuantity');
        }
        this.validate();
        this._onQuantityChange.dispatch(quantity);
    }

    resetQuantity(){
        return this.view.resetQuantity();
    }

    setProductName(name: string) {
        this.view.setProductName(name);
    }

    validate = async () => {
        this.view.hideError();
        const validatorResult = this.validator.validate({ id: this.view.id });
        const isValid = await validatorResult;
        if (!isValid) {
            this.view.showError();
        }
        return validatorResult;
    }

    showForm() {
        this.view.showForm();
    }

    hideForm() {
        this.view.hideForm();
    }

}
